import { render, staticRenderFns } from "./Reflection.vue?vue&type=template&id=a2994088&scoped=true&lang=pug&"
import script from "./Reflection.ts?vue&type=script&lang=ts&"
export * from "./Reflection.ts?vue&type=script&lang=ts&"
import style0 from "./Reflection.vue?vue&type=style&index=0&id=a2994088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2994088",
  null
  
)

export default component.exports